import { render } from "./1TeamHero.vue?vue&type=template&id=2d5ed088&scoped=true"
import script from "./1TeamHero.vue?vue&type=script&lang=js"
export * from "./1TeamHero.vue?vue&type=script&lang=js"

import "./1TeamHero.vue?vue&type=style&index=0&id=2d5ed088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5ed088"]])

export default __exports__